import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function GamePage() {
  const { gameId } = useParams<{ gameId: string }>();
  const { isAuthenticated } = useAuth();
  const [gameUrl, setGameUrl] = useState<string | null>(null);
  const [gameName, setGameName] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const launchGame = async () => {
      if (!gameId) {
        setError('ID do jogo não fornecido.');
        setLoading(false);
        return;
      }

      if (!isAuthenticated) {
        setError('Usuário não autenticado. Faça login para jogar.');
        setLoading(false);
        return;
      }

      try {
        const response = await api.post(`/games/${gameId}/launch`);

        if (response.data.success && response.data.game_url) {
          setGameUrl(response.data.game_url);
          setGameName(response.data.game_name);
        } else {
          setError(response.data.error || 'Erro ao iniciar o jogo.');
        }
      } catch (err) {
        setError('Erro ao conectar com o servidor de jogos.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    launchGame();
  }, [gameId, isAuthenticated]);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (gameUrl && isMobile && iframeRef.current) {
      try {
        iframeRef.current.requestFullscreen();
      } catch (err) {
        console.error("Erro ao tentar entrar em tela cheia:", err);
      }
    }
  }, [gameUrl]);

  if (loading) {
    return <div className="text-center text-gray-600">Carregando jogo...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600">Erro: {error}</div>;
  }

  if (!gameUrl) {
    return <div className="text-center text-gray-600">Nenhuma URL de jogo disponível.</div>;
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-screen bg-gray-900">
      <h1 className="text-white text-xl mb-4">{`Jogando: ${gameName || gameId}`}</h1>
      <iframe
        ref={iframeRef}
        src={gameUrl}
        title="Game Session"
        className="w-full h-full border-none"
        allow="fullscreen; autoplay; encrypted-media"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
      ></iframe>
    </div>
  );
}
